import React from 'react';

import Loading from 'components/base/Loading';

import { withAuthenticationRequired } from '@auth0/auth0-react';
import { IntegrationView } from '@relyant/ui';

export const IntegrationsComponent = () => {
  return <IntegrationView />;
};

export default withAuthenticationRequired(IntegrationsComponent, {
  onRedirecting: () => <Loading />,
});
